import { render, staticRenderFns } from "./BuyCards.vue?vue&type=template&id=2d01ef62&lang=pug"
import script from "./BuyCards.vue?vue&type=script&lang=js"
export * from "./BuyCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports